export default function InstructorProfileSkeleton() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-zinc-950 pt-32 pb-16 animate-pulse" dir="rtl">
      <div className="container mx-auto px-4 max-w-5xl">

        {/* Header Card */}
        <div className="bg-white dark:bg-zinc-900 border border-slate-200 dark:border-white/10 rounded-3xl p-8 md:p-12 mb-8 shadow-sm">
          <div className="flex flex-col md:flex-row items-center gap-8">
            {/* Avatar */}
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-zinc-200 dark:bg-zinc-800 shrink-0" />

            <div className="flex-1 text-center md:text-right space-y-4 w-full">
              {/* Name */}
              <div className="h-8 w-48 rounded-xl bg-zinc-200 dark:bg-zinc-800 mx-auto md:mx-0" />
              {/* Specialization badge */}
              <div className="h-6 w-28 rounded-full bg-zinc-200 dark:bg-zinc-800 mx-auto md:mx-0" />
              {/* Bio lines */}
              <div className="space-y-2.5 max-w-lg mx-auto md:mx-0">
                <div className="h-4 w-full rounded bg-zinc-200 dark:bg-zinc-800" />
                <div className="h-4 w-[90%] rounded bg-zinc-200 dark:bg-zinc-800" />
                <div className="h-4 w-[70%] rounded bg-zinc-200 dark:bg-zinc-800" />
              </div>
              {/* Social icons */}
              <div className="flex items-center gap-3 justify-center md:justify-start mt-4">
                {[1, 2, 3].map(i => (
                  <div key={i} className="w-10 h-10 rounded-xl bg-zinc-200 dark:bg-zinc-800" />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="bg-white dark:bg-zinc-900 border border-slate-200 dark:border-white/10 rounded-2xl p-5">
              <div className="h-4 w-16 rounded bg-zinc-200 dark:bg-zinc-800 mb-3" />
              <div className="h-8 w-12 rounded bg-zinc-200 dark:bg-zinc-800" />
            </div>
          ))}
        </div>

        {/* Courses section title */}
        <div className="h-7 w-36 rounded-lg bg-zinc-200 dark:bg-zinc-800 mb-6" />

        {/* Course cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map(i => (
            <div key={i} className="aspect-[3/4] min-h-[350px] rounded-3xl bg-zinc-200 dark:bg-zinc-800" />
          ))}
        </div>
      </div>
    </div>
  );
}
